import { combineReducers, legacy_createStore as createStore } from "redux";
import store from "../Reducers/storeReducer";
const rootReducer = combineReducers({
  store,
});

export default createStore(rootReducer);
